export const getAlchemyStaticStyles = (options, scope = '') => 
// const getOption = getOptionFunc(options);
// const theme = getOption<string>('themeOption');
// const isLightTheme = theme === 'light';
// const backgroundColor = isLightTheme ? '#ffffff' : '#ffffff';
// const borderColor = isLightTheme ? '#ababab' : '#333333';
`
        .mas-alchemy-default-background {
            background: linear-gradient(#2c3548, #121826);
            height: 100%;
            overflow: auto;
            position: relative;
            font-weight: 300;
        }

        .mas-drop-menu {
            border-radius: 16px;
            transition: box-shadow 0.1s ease 0s;
            box-shadow: rgb(0 0 0 / 8%) 0px 2px 4px 0px, rgb(0 0 0 / 18%) 0px 6px 18px 0px;
        }

        .mas-application-type-name {
            font-weight: bold;
        }

        ${scope} .mas-app-menu-list {
            padding: 1px;
        }

        /* login form */
        ${scope} form {
            width: 85%;
            margin: 0 auto;
        }

        ${scope} form label {
            color: #ffffff;
        }

        ${scope} .mas-form-title {
            color: #ffffff;
            font-size: 1.5em;
            text-align: center;
            margin: .25em auto .75em;
        }

        ${scope} form input[type='text'],
        ${scope} form input[type='password'],
        ${scope} form input[type='textarea'] {
            box-sizing: border-box;
            border: 1px solid #CED4DA;
            background-color: #ffffff;
            outline: none;
            width: 100%;
            font-size: 14px;
            font-style: italic;
            height: 32px;
            border-radius: 16px;
            margin-top: .5em;
            margin-bottom: 1.5em;
            padding: 0 0 0 10px;
            color: #2C3548;
            animation-name: none;
        }

        ${scope} form input:focus {
            border: 2px solid rgb(64, 80, 198);
            outline: none;
        }

        ${scope} form button[type='submit'] {
            color: #fff;
            background-image: linear-gradient(90deg, #4E5DCA, #6B71CE);
            border-radius: 16px;
            cursor: pointer;
            font-weight: 500;
            margin-top: .5em;
            margin-bottom: 1.5em;
            height: 32px;
            border: none;
            padding: 0;
            outline: none;
            width: 100%;
        }

        /* drop menu */
        ${scope} ul {
            list-style-type: none;
            margin: 0;
            padding: 0;
        }

        ${scope} .mas-app-menu-header {
            text-align: center;
            padding: .5rem 0;
        }

        ${scope} .mas-app-menu-header-text {
            font-family: Nunito, -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", "Oxygen Sans", Ubuntu, "Helvetica Nue", sans-serif;
            font-weight: 700;
            font-size: 18px;
            line-height: 1.33;
            float: left;
            padding-left: 1em;
            padding-bottom: 0.5em;
         }

        ${scope} .mas-application-type-logo-wrap {
            position: absolute;
            left: 16px;
            top: 14px;
        }

        ${scope} .mas-application-type-logo-wrap > .icon-wrap-0 {
            display: flex;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
            flex-shrink: 0;
            background-color: rgb(198, 115, 64);
            border-radius: 6px;
            height: 34px;
            width: 34px;
            transform: rotate(45deg);
        }

        ${scope} .mas-application-type-logo-wrap > .icon-wrap-0.icon-wrap-blue {
            background-color: rgb(82, 177, 255);
        }

        ${scope} .mas-application-type-logo-wrap > .icon-wrap-0.icon-wrap-green {
            background-color: rgb(1, 188, 213);
        }

        ${scope} .mas-application-type-logo-wrap > .icon-wrap-0 > .icon-wrap-1 {
            height: 20px;
            transform: rotate(-45deg);
        }

        ${scope} .mas-application-type-logo-wrap > .icon-wrap-0 > .icon-wrap-1 > .icon-actual {
            color: rgb(255, 255, 255);
            margin-right: 0px;
        }

        ${scope} .mas-expandable-application-trigger {
            position: absolute;
            right: 16px;
            top: 12px;
        }

        ${scope} .mas-app-menu-list-item,
        ${scope} .mas-app-menu-application-item {
            position: relative;
            display: flex;
            font-family: Nunito, -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", "Oxygen Sans", Ubuntu, "Helvetica Nue", sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 1.5;
            color: rgb(27, 36, 55);
            min-height: 28px;
            padding: 4px 0px;
            width: 100%;
            border-top: none;
            background-color: #ffffff;
        }

        ${scope} li.highlighted {
            background-color: rgb(234, 243, 255);
        }

        ${scope} li.highlighted::before {
            content: "";
            width: 3px;
            position: absolute;
            top: 3px;
            left: 3px;
            bottom: 3px;
            background-color: rgb(46, 119, 208);
            border-radius: 2px;
        }

        ${scope} li.highlighted.mas-app-menu-list-item:hover::before {
            width: 4px;
            background-color: rgb(46, 119, 208);
            opacity: 1.0;
        }


        ${scope} .mas-app-menu-application-item {
            padding-left: 32px;
        }

        ${scope} .mas-app-menu-list-item:hover,
        ${scope} .mas-app-menu-application-item:hover {
            background-color: rgb(234, 243, 255);
        }

        ${scope} .mas-app-menu-list-item:hover::before,
        ${scope} .mas-app-menu-application-item:hover::before {
            content: "";
            width: 4px;
            position: absolute;
            top: 3px;
            left: 3px;
            bottom: 3px;
            background-color: rgb(46, 119, 208);
            opacity: 0.5;
            border-radius: 2px;
        }

        ${scope} .mas-application-type-list-item-button {
            position: relative;
            display: flex;
            width: 100%;
            min-height: 36px;
            padding: 0px 16px 0px 78px;

            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: start;
            justify-content: flex-start;
            text-decoration: none;

            appearance: none;
            background-color: transparent;
            border: none;
            cursor: pointer;
            font-size: inherit;
            font-weight: 500;
            line-height: inherit;
            text-align: center;
        }

        ${scope} .mas-application-link-anchor {
            opacity: 1;
            color: rgb(27, 36, 55);
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: start;
            justify-content: flex-start;
            position: relative;
            width: 100%;
            min-height: 53px;
            padding: 0px 16px;
            text-decoration: none;
        }

        ${scope} .mas-static-link-anchor {
            opacity: 1;
            color: rgb(27, 36, 55);
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: start;
            justify-content: flex-start;
            position: relative;
            width: 100%;
            min-height: 53px;
            text-decoration: none;
            font-family: Nunito, -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", "Oxygen Sans", Ubuntu, "Helvetica Nue", sans-serif;
            font-weight: 700;
        }

        ${scope} .mas-logout-button-wrap {
            text-align: right;
            padding: .5rem;
        }

        ${scope} .mas-logout-button {
            font-family: Nunito, -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", "Oxygen Sans", Ubuntu, "Helvetica Nue", sans-serif;
            font-weight: 500;
            font-size: 14px;
            appearance: none;
            cursor: pointer;
            display: inline-block;
            line-height: 1;
            position: relative;
            text-align: center;
            white-space: nowrap;
            background-color: transparent;
            color: rgb(46, 119, 208);
            min-height: 34px;
            border-width: 1px;
            border-style: solid;
            border-image: initial;
            margin: 0px;
            text-decoration: none;
            transition: background-color 200ms cubic-bezier(0.75, -0.15, 0.35, 1.15) 0s, border-color, color;
            border-color: rgb(206, 212, 218);
            border-radius: 34px;
            padding: 10px 16px;
        }
`;
